import Box from "@mui/material/Box";
import { Link, Route, Routes, useLocation } from "react-router-dom";
import { useAppContext } from "../../AppContext";
import { useLocalizedStrings } from "../../localization/LocalizedStringsProvider";
import { fillHeight } from "../../theme";

const Employees = () => {
    const location = useLocation();
    const strings = useLocalizedStrings();
    const app = useAppContext();

    return (
        <Box sx={{ ...fillHeight, overflow: "hidden" }}>
        </Box>
    );
};

export default Employees;